import React, { useState } from 'react';
import { Play, X } from 'lucide-react';

const ProductGallery = ({ images = [], video }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);

  // Normalize images: accept both string arrays and {url, alt} object arrays
  const normalizedImages = (images && images.length > 0)
    ? images.map((img, i) =>
        typeof img === 'string'
          ? { url: img, alt: `Imagem ${i + 1}` }
          : img
      )
    : [{ url: '/placeholder.png', alt: 'Sem imagem' }];

  return (
    <div className="space-y-4">
      <div className="relative h-[500px] bg-gray-100 rounded-xl overflow-hidden">
        {showVideo && video ? (
          <div className="relative w-full h-full">
            <video
              src={video}
              controls
              autoPlay
              className="w-full h-full object-contain"
            />
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-4 right-4 w-10 h-10 bg-black bg-opacity-50 hover:bg-opacity-75 rounded-full flex items-center justify-center transition-all"
            >
              <X className="w-5 h-5 text-white" />
            </button>
          </div>
        ) : (
          <img
            src={normalizedImages[selectedIndex]?.url}
            alt={normalizedImages[selectedIndex]?.alt || 'Produto'}
            className="w-full h-full object-contain"
          />
        )}
      </div>

      {normalizedImages.length > 1 && (
        <div className="flex gap-2 overflow-x-auto">
          {video && (
            <button
              onClick={() => setShowVideo(true)}
              className="relative flex-shrink-0 w-20 h-20 bg-black rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <Play className="w-8 h-8 text-white fill-white" />
              </div>
            </button>
          )}

          {normalizedImages.map((image, index) => (
            <button
              key={index}
              onClick={() => {
                setSelectedIndex(index);
                setShowVideo(false);
              }}
              className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden cursor-pointer transition-all ${
                selectedIndex === index && !showVideo
                  ? 'ring-2 ring-aug-blue opacity-100'
                  : 'opacity-60 hover:opacity-100'
              }`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
